export default {
  topNav: {
    about: 'О компании',
    companyName: 'Ак Барс Дом',
    groupOfCompanies: 'Группа компаний «АБД»',
    FAQ: 'Вопросы и ответы',
    documents: 'Документы',
    purchase: 'Способы покупки',
    ownershipDetails: 'Электронная сделка',
    mortgage: 'Ипотека',
    tradeIn: 'Трейд-ин',
    installment: 'Рассрочка',
    maternityCapital: 'Материнский капитал',
    certificatesAndGrants: 'Сертификаты и субсидии',
    stocks: 'Акции',
    news: 'Новости',
    article: 'Статьи',
    contacts: 'Контакты',
    magazine: 'Журнал М²'
  },
  topInfo: {
    cityName: 'г. Казань',
    getRecall: 'Заказать звонок'
  },
  downNav: {
    flats: 'Квартиры',
    housingComplex: 'Жилые комплексы',
    commercialEstate: 'Коммерческая недвижимость',
    buyFlatOnline: 'Купить квартиру онлайн'
  },
  myProfile: {
    goToPersonalPage: 'Управляющая компания',
    title: 'Мой профиль',
    completeProfile: 'Заполнить профиль',
    goMain: 'На главную',
    consultation: 'Консультация',
    exit: 'Выйти'
  }
}
